import { OneTimeProduct, ProductsWithMedicationForm } from "src/api/types";
import LatestOnlineVisitsProvider from "src/context/LatestOnlineVisits";
import Item from "src/pages/PatientDashboard/components/MembersFavorites/components/Product";

interface Props {
  products: ProductsWithMedicationForm[];
  recommendedDose?: OneTimeProduct;
}

const ProductItems = ({ products, recommendedDose }: Props) => {
  return (
    <LatestOnlineVisitsProvider>
      {products.map((p, idx) => (
        <Item
          product={p}
          recommendedDose={recommendedDose}
          key={`${idx}-${p.id}`}
        />
      ))}
    </LatestOnlineVisitsProvider>
  );
};

export default ProductItems;
